export const MERCHANT_ID='BCR2DN4T22DMNEIX'
export const MERCHANT_NAME='SecurePlay'
export const GATEWAY_MERCHANT_ID='252190'
export const MERCHANT_GATEWAY='crst'
export const ASSET_URL='https://ems-dev-clone1.sems.me/mi-eventmaster/html/images/packages/'